import { useState, useEffect, useMemo } from 'react';
import { useGrowthBookValues } from '../contexts/GrowthBookContext';

const MOBILE_MEDIA = '(max-width: 768px)';

export const useVideoAnimation = () => {
  const { animatedPictures: animationMode } = useGrowthBookValues();
  const isTouchDevice = useMemo(() => {
    if (typeof window === 'undefined') return false;

    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      /android|iphone|ipad|ipod/i.test(navigator.userAgent)
    );
  }, []);

  const [isMobileViewport, setIsMobileViewport] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(MOBILE_MEDIA).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(MOBILE_MEDIA);

    const handler = (e) => {
      setIsMobileViewport(e.matches);
    };

    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, []);

  const isMobile = isTouchDevice && isMobileViewport;

  const shouldAutoPlay = animationMode === 'AUTOMATIC';
  const shouldShowVideos = animationMode !== 'OFF';

  const getVideoProps = () => ({
    autoPlay: shouldAutoPlay,
    loop: true,
    muted: true,
    playsInline: true,
    preload: 'auto',
  });

  const shouldPlayOnHoverOrSelected = animationMode === 'MOUSEOVER';

  // Для step0: если OFF, то ведём себя как MOUSEOVER
  const shouldPlayOnHoverOrSelectedForStep0 = animationMode === 'MOUSEOVER' || animationMode === 'OFF';

  return {
    animationMode,
    isMobile,
    isTouchDevice,
    isMobileViewport,
    shouldAutoPlay,
    shouldPlayOnHoverOrSelected,
    shouldPlayOnHoverOrSelectedForStep0,
    shouldShowVideos,
    getVideoProps,
  };
};
